import React from 'react';

type AlignIconType = 'left' | 'right' | 'hcenter' | 'top' | 'bottom' | 'vcenter' | 'distribute-h' | 'distribute-v';

interface AlignIconProps {
  type: AlignIconType;
  disabled?: boolean;
}

export const AlignIcon: React.FC<AlignIconProps> = ({ type, disabled }) => {
  const size = 16;
  const strokeWidth = 1.5;
  const color = disabled ? '#bbb' : '#666';
  
  switch (type) {
    case 'left':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <line x1="2" y1="3" x2="2" y2="13" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="4" y="6" width="10" height="4" fill={color}/>
        </svg>
      );
    case 'distribute-h':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <line x1="2" y1="2" x2="2" y2="14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="6" y="5" width="4" height="6" fill={color}/>
          <line x1="14" y1="2" x2="14" y2="14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
        </svg>
      );
    case 'right':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <rect x="2" y="6" width="10" height="4" fill={color}/>
          <line x1="14" y1="3" x2="14" y2="13" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
        </svg>
      );
    case 'hcenter':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <rect x="2" y="6" width="4" height="4" fill={color}/>
          <line x1="8" y1="3" x2="8" y2="13" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="10" y="6" width="4" height="4" fill={color}/>
        </svg>
      );
    case 'top':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <line x1="3" y1="2" x2="13" y2="2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="6" y="4" width="4" height="10" fill={color}/>
        </svg>
      );
    case 'distribute-v':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <line x1="2" y1="2" x2="14" y2="2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="5" y="6" width="6" height="4" fill={color}/>
          <line x1="2" y1="14" x2="14" y2="14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
        </svg>
      );
    case 'bottom':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <rect x="6" y="2" width="4" height="10" fill={color}/>
          <line x1="3" y1="14" x2="13" y2="14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
        </svg>
      );
    case 'vcenter':
      return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
          <rect x="6" y="2" width="4" height="4" fill={color}/>
          <line x1="3" y1="8" x2="13" y2="8" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
          <rect x="6" y="10" width="4" height="4" fill={color}/>
        </svg>
      );
    default:
      return null;
  }
};

